import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=4908b7ce"
import script from "./EmailInput.vue?vue&type=script&lang=js"
export * from "./EmailInput.vue?vue&type=script&lang=js"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=4908b7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports